import React, { useState, useEffect } from "react";

const ChatComponent = ({ matchId }) => {
  const [activeTab, setActiveTab] = useState("LIVE_CHAT");
  const [rankingData, setRankingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRankingData = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const myHeaders = new Headers();
      myHeaders.append("Cookie", "SERVER=api1");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        "https://api.luongson.chat/api/history-send-gift/ranks?ownedByBLV=219",
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setRankingData(data.data); // Lưu dữ liệu từ API
    } catch (error) {
      console.error("Error fetching ranking data:", error);
      setError("Không thể tải dữ liệu bảng xếp hạng.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "RANKING_CHAT") {
      fetchRankingData();
    }
  }, [activeTab]);

  return (
    <div className="tw-h-full tw-rounded tw-bg-gradient-to-b tw-from-[#231ABD] tw-to-[#0A1D89] tw-p-0.5">
      <div
        dir="ltr"
        data-orientation="horizontal"
        className="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-1.5"
      >
        {/* Tab Buttons */}
        <div
          role="tablist"
          aria-orientation="horizontal"
          className="tw-inline-flex tw-items-center tw-justify-center tw-bg-muted tw-text-muted-foreground tw-h-9 tw-w-full tw-rounded tw-p-0 tw-bg-white"
        >
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "LIVE_CHAT"}
            onClick={() => setActiveTab("LIVE_CHAT")}
            className={`tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-md tw-transition-all tw-h-9 tw-w-full tw-p-0 tw-text-sm tw-font-semibold ${
              activeTab === "LIVE_CHAT"
                ? "tw-bg-[linear-gradient(90deg,#FFDE29_0%,#FFF17A_18.5%,#FFDE29_38%,#FFD852_58%,#FFF17A_75.5%,#FFDE29_88%,#FE7_100%)] tw-text-black"
                : "tw-bg-white"
            }`}
          >
            <span>Phòng chat</span>
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "RANKING_CHAT"}
            onClick={() => setActiveTab("RANKING_CHAT")}
            className={`tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-md tw-transition-all tw-h-9 tw-w-full tw-p-0 tw-text-sm tw-font-semibold ${
              activeTab === "RANKING_CHAT"
                ? "tw-bg-[linear-gradient(90deg,#FFDE29_0%,#FFF17A_18.5%,#FFDE29_38%,#FFD852_58%,#FFF17A_75.5%,#FFDE29_88%,#FE7_100%)] tw-text-black"
                : "tw-bg-white"
            }`}
          >
            <span>Bảng xếp hạng</span>
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "LIVE_CHAT" && (
          <div
            role="tabpanel"
            aria-labelledby="LIVE_CHAT"
            className="tw-ring-offset-background tw-mt-0 tw-h-[calc(100%-42px)] tw-w-full tw-bg-zinc-100 tw-rounded"
          >
            <iframe
              src={`https://luongson.tv/embed-chat/${matchId}`}
              title="chat"
              className="tw-h-full tw-w-full tw-pt-2"
              allow="autoplay"
              frameBorder="0"
              marginHeight="0"
            ></iframe>
          </div>
        )}
        {activeTab === "RANKING_CHAT" && (
          <div
            role="tabpanel"
            aria-labelledby="RANKING_CHAT"
            className="tw-ring-offset-background tw-mt-0 tw-h-[calc(100%-42px)] tw-w-full tw-bg-zinc-100 tw-rounded tw-p-4 tw-overflow-y-auto"
          >
            {isLoading && <p>Đang tải dữ liệu...</p>}
            {error && <p className="tw-text-red-500">{error}</p>}
            {!isLoading && !error && rankingData.length > 0 ? (
              <ul className="tw-divide-y">
                {rankingData.map((rank, index) => (
                  <li
                    key={rank.id}
                    className="tw-flex items-center tw-justify-between tw-p-2 hover:tw-bg-stone-200 "
                  >
                    <div className="tw-flex tw-items-center tw-gap-2">
                      <span
                        className={`tw-block tw-h-5 tw-w-5 tw-rounded-full tw-text-center font-fz-kn-game tw-text-white ${
                          index === 0 || index === 1 || index === 2
                            ? "tw-bg-red-600"
                            : " !tw-text-black"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span
                        className={`tw-inline tw-h-fit tw-rounded tw-px-1.5 tw-text-xs tw-font-semibold tw-text-black md:tw-text-sm ${
                          rank.level === 1
                            ? "tw-bg-[#b7b4ff]"
                            : rank.level === 2
                            ? "tw-bg-[#70c789]"
                            : rank.level === 3
                            ? "tw-bg-[#376bfd]"
                            : rank.level === 4
                            ? "tw-bg-[#f5f519]"
                            : "tw-bg-[#facc15]"
                        }`}
                      >
                        Lv{rank.level}
                      </span>
                      <span className="tw-truncate tw-text-sm tw-font-medium">
                        {rank.fullName}
                      </span>
                    </div>
                    <div>
                      <span className="tw-text-xs tw-font-medium tw-text-stone-900">
                        Đóng góp {rank.totalPoints}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              !isLoading && !error && <p>Không có dữ liệu xếp hạng.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatComponent;
